import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { QueryParamDirective } from './query-param.directive';

@NgModule({
  exports: [QueryParamDirective],
  imports: [CommonModule, QueryParamDirective],
})
export class QueryParamModule {}
